import { Link, useParams } from "react-router-dom";
import { resolveImageUrl } from "../../utils/ImageUrl";
import { usePublicSiteData } from "./PublicSiteContext";

const NAV_LINKS = [
  { label: "Home", to: "" },
  { label: "Services", to: "services" },
  { label: "Gallery", to: "gallery" },
  { label: "About Us", to: "about-us" },
  { label: "Contact", to: "contact" },
];

const PublicHeader = () => {
  const { slug } = useParams<{ slug: string }>();
  const website = usePublicSiteData();
  const org = website?.organization;

  const base = `/${slug ?? ""}`;
  const phone = website?.organization.phone;

  return (
    <header className="psite-header">
      <div className="psite-header__inner">
        <Link to={base} className="psite-logo">
          {org?.logoUrl ? (
            <img src={resolveImageUrl(org.logoUrl)} alt={org.name} />
          ) : (
            <span>{org?.name ?? "Clinic"}</span>
          )}
        </Link>

        <nav className="psite-nav" aria-label="Main navigation">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to === "" ? base : `${base}/${link.to}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="psite-header__right">
          {phone && (
            <a className="psite-phone" href={`tel:${phone}`}>
              {phone}
            </a>
          )}
          <Link
            className="psite-btn psite-btn--primary"
            to={`${base}#appointment`}
          >
            Make An Appointment
          </Link>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
